import React, { useState } from "react";
import { useDispatch } from "react-redux";
import PdvController from "../../Controller/PdvCotroller";
import { toast, ToastContainer } from "react-toastify"; // Import ToastContainer from react-toastify
import "react-toastify/dist/ReactToastify.css"; // Import Toastify styles

const ChangePassword = () => {
  const dispatch = useDispatch();
  const [currentPassword, setCurrentPassword] = useState("");
  const [newPassword, setNewPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [loading, setLoading] = useState(false);

  // Function to handle password change
  const handleChangePassword = async (e) => {
    e.preventDefault();
    setLoading(true);

    // Reset previous toast messages before sending the request
    toast.dismiss();

    // Check if the passwords match
    if (newPassword !== confirmPassword) {
      toast.error("Passwords do not match.");
      setLoading(false);
      return;
    }

    const data = {
      current_password: currentPassword,
      password: newPassword,
      password_confirmation: confirmPassword,
    };

    try {
      // Call the method to update the password via PdvController
      const response = await PdvController.ModifierPassword(data);

      // Check if the response indicates success or failure
      if (response.success) {
        toast.error(response.message || "The current password is incorrect.");
      } else {
        toast.success(response.message || "Password changed successfully!");
      }
    } catch (error) {
      // Display an error message if the request fails
      toast.error(error.response ? error.response.data.message : "An unexpected error occurred.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="accountsettings">
      <h1 className="mainhead1">Change Password</h1>
      <form onSubmit={handleChangePassword}>
        <div className="form">
          <div className="form-group">
            <label htmlFor="currentPassword">
              Current Password <span>*</span>
            </label>
            <input
              type="password"
              id="currentPassword"
              value={currentPassword}
              onChange={(e) => setCurrentPassword(e.target.value)}
              placeholder="Current Password"
              required
            />
          </div>

          <div className="form-group">
            <label htmlFor="newPassword">
              New Password <span>*</span>
            </label>
            <input
              type="password"
              id="newPassword"
              value={newPassword}
              onChange={(e) => setNewPassword(e.target.value)}
              placeholder="New Password"
              required
            />
          </div>

          <div className="form-group">
            <label htmlFor="confirmPassword">
              Confirm New Password <span>*</span>
            </label>
            <input
              type="password"
              id="confirmPassword"
              value={confirmPassword}
              onChange={(e) => setConfirmPassword(e.target.value)}
              placeholder="Confirm New Password"
              required
            />
          </div>
        </div>

        <button type="submit" disabled={loading} className="mainbutton1">
          {loading ? "Changing..." : "Change Password"}
        </button>
      </form>

      {/* ToastContainer is where toast notifications will be displayed */}
      <ToastContainer
        position="top-right" // Position of the toast
        autoClose={5000} // Toast duration in milliseconds
        hideProgressBar={false} // Show progress bar
        newestOnTop={false} // Show newest toast on top
        closeOnClick // Close on click
        rtl={false} // Direction (for RTL languages)
        pauseOnFocusLoss // Pause when focused out
        draggable // Allow dragging
        pauseOnHover // Pause when hovered
      />
    </div>
  );
};

export default ChangePassword;
